import leftButtonGroupStyle from '../../css/licenses-left-button-group.module.css';

// Components
import Button from 'components/Button';

import { useTranslation } from "react-i18next";

const LeftButtonGroupORG = props => {
  const { t } = useTranslation();
  const { modalStatus, changeModalStatus } = props;

  return (
    <div
      className={`d-flex justify-content-between ${leftButtonGroupStyle['left-button-group-contianer']}`}
    >
      <Button
        label={t('412a9172e0')}
        disabled={modalStatus.addLicense.disabled}
        onClick={() => changeModalStatus('addLicense', true)}
      ></Button>
    </div>
  );
};

export default LeftButtonGroupORG;